import request from '@/utils/request'

// 详情页查询开票记录列表
export function listContractInvoice(query) {
  return request({
    url: '/crmContractInvoice/queryListByCustomerId',
    method: 'get',
    params: query
  })
}

// 分页查询合同列表
export function pageContractInvoice(query) {
  return request({
    url: '/crmContractInvoice/queryList',
    method: 'get',
    params: query
  })
}

// 查询合同详情
export function queryContractInvoiceDetail(query) {
  return request({
    url: '/crmContractInvoice/queryDetail',
    method: 'get',
    params: query
  })
}

// 更新合同
export function updateContractInvoice(data) {
  return request({
    url: '/crmContractInvoice/update',
    method: 'put',
    data: data
  })
}
